


/**
 * Supplies helpers for reading individual or all query parameters from the URL.
 * @returns Tuple with functions for getting a single param and the full parameter map.
 */
export function useQueryParams() {

 

    /**
     * Reads a specific query string value from the current location.
     * @param name - Query parameter key to retrieve.
     * @returns Matching value or null when absent.
     */
    const getQueryParams = (name: string) => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        return urlSearchParams.get(name);
    }

    /**
     * Builds an object containing every query string entry.
     * @returns Map of query parameter keys to their string values.
     */
    const allParams = () => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params: any = {};
        for (const [key, value] of urlSearchParams.entries()) {
            params[key] = value;
        }
        return params;
    }


    return [getQueryParams, allParams] as const;
}